
define('unknown/views/pwActView',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/pwActModel',
	'unknown/models/pwActKeyModel'
], function($, _, Backbone, LoginModel, PwActModel, PwActKeyModel){
	var PwActFooterView = Backbone.View.extend({
		events: {
			'click #pwResetActFormSubmit': 'submitForm'
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showForm();
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'defaultPass', this.showForm);
			this.listenTo(this.event, 'savingPass', this.showNonForm);
			this.listenTo(this.event, 'savingKey', this.showNonForm);
			this.listenTo(this.event, 'errorKeyAct', this.showNonForm);
			this.listenTo(this.event, 'errorKey', this.showForm);
			this.listenTo(this.event, 'errorPass', this.showForm);
			this.listenTo(this.event, 'success', this.showNonForm);
		},
		
		submitForm: function () {
			this.event.trigger("save");
		},
		
		showForm: function () {
			this.$("#pwResetActFormSubmit").show();
		},
		
		showNonForm: function () {
			this.$("#pwResetActFormSubmit").hide();
		},
	});

	var PwActContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.pwKeyModel = options.pwKeyModel;
			this.pwResetModel = options.pwResetModel;
			this.keyValidated = false;
			this.event = options.event;
			this.submittedData = options.submittedData;
			
			this.hideAll();
			
			_.bindAll(this, 'successKeyCallback');
			_.bindAll(this, 'errorKeyCallback');
			_.bindAll(this, 'successResetCallback');
			_.bindAll(this, 'errorResetCallback');
			_.bindAll(this, 'formEnter');
			
			
			
			$('#pwResetActBodyContentForm').on("keyup", this.formEnter);
			$('#pwResetActBodyContentPassForm').on("keyup", this.formEnter);
			
			this.listenTo(this.event, 'save', this.submitForm);
			this.listenTo(this.event, 'default', this.keyForm);
			this.listenTo(this.event, 'defaultPass', this.passForm);
			this.listenTo(this.event, 'savingPass', this.passProcessing);
			this.listenTo(this.event, 'savingKey', this.keyProcessing);
			this.listenTo(this.event, 'errorKeyAct', this.alreadyActivated);
			this.listenTo(this.event, 'errorKey', this.keyForm);
			this.listenTo(this.event, 'errorPass', this.passForm);
			this.listenTo(this.event, 'success', this.success);
			
			
			//Error handling
			this.listenTo(this.event, 'errorPass:password', this.errorPassword);
		},
		
		submitForm: function () {
			if(!this.submittedData.isSubmitted){
				if(this.keyValidated){
					//Key has been validated so submit the password
					this.event.trigger("savingPass");
					
					var submittable = false;
					var password = this.$("#pwResetActPassInput").val();
					
					if(password){
						if (password.length < 5) {
							this.event.trigger("errorPass");
							this.event.trigger("errorPass:password", "LENGTH");
						} else {
							submittable = true;
						} 
					} else {
						this.event.trigger("errorPass");
						this.event.trigger("errorPass:password", "NULL");
					}
					
					this.pwResetModel.set("key", this.pwKeyModel.get("key"), {silent: true});
					
					if(submittable){
						this.submittedData.isSubmitted = true;
						
						this.pwResetModel.save({
							activationType : "PWRESET",
							password : password ? $.sha256(password) : ""
						},{wait: true,
							success : this.successResetCallback, 
							error : this.errorResetCallback
						});
					}
				} else {
					//Key hasn't been validated so go retrieve that
					this.event.trigger("savingKey");
					
					var key = this.$("#pwResetActKeyInput").val();
					
					if(key && key.length > 0){
						this.submittedData.isSubmitted = true;
						
						this.pwKeyModel.set("key", key, {silent: true});
						
						this.pwKeyModel.fetch({
							success: this.successKeyCallback,
							error: this.errorKeyCallback,
						});
					} else {
						this.event.trigger("errorKey");
					}
				}
			}
		},
		
		successKeyCallback: function(model, response) {
			this.event.trigger("savingKeySuccess", model, response);
		},
		
		errorKeyCallback: function(model, error) {
			this.event.trigger("savingKeyError", model, error);
		},
		
		successResetCallback: function(model, response) {
			this.event.trigger("savingResetSuccess", model, response);
		},
		
		errorResetCallback: function(model, error) {
			this.event.trigger("savingResetError", model, error);
		},
		
		formEnter: function(e) {
			var code = e.keyCode || e.which; 
			if (code  == 13) {               
				e.preventDefault();
				this.event.trigger("save");
				return false;
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#pwResetActBodyContentForm").hide();
			this.$("#pwResetActBodyContentPassForm").hide();
			this.$("#pwResetActBodyContentKeyProcessing").hide();
			this.$("#pwResetActBodyContentPasswordProcessing").hide();
			this.$("#pwResetActBodyContentAlreadyActivated").hide();
			this.$("#pwResetActBodyContentSuccess").hide();
			
			//Hide error messages
			this.$("#pwResetActKeyGrp").removeClass("error");
			this.$("#pwResetActKeyInput").removeClass("error");
			this.$("#pwResetActKeyErrMsg").hide();
			
			this.$("#pwResetActPassGrp").removeClass("error");
			this.$("#pwResetActPassInput").removeClass("error");
			this.$("#pwResetActPassErrMsg").hide();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetActBodyContentSuccess").show();
		},
		
		alreadyActivated: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetActBodyContentAlreadyActivated").show();
		},
		
		keyProcessing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetActBodyContentKeyProcessing").show();
		},
		
		passProcessing: function () {
			this.hideAll();
			this.$("#pwResetActBodyContentPasswordProcessing").show();
		},
		
		keyForm: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetActBodyContentForm").show();
		},
		
		passForm: function () {
			this.keyValidated = true;
			
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetActBodyContentPassForm").show();
		},
		
		errorPassword : function (errorCode) {
			this.$("#pwResetActPassGrp").addClass("error");
			this.$("#pwResetActPassInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#pwResetActPassErrMsg").html("Password is empty");
					this.$("#pwResetActPassErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#pwResetActPassErrMsg").html("Password must be at least 5 characters long");
					this.$("#pwResetActPassErrMsg").show();
					break;
				default : 
					this.$("#pwResetActPassErrMsg").html("Password is invalid");
			}
		},
	});

	var PwActMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'defaultPass', this.hideAll);
			this.listenTo(this.event, 'savingPass', this.passProcessing);
			this.listenTo(this.event, 'savingKey', this.keyProcessing);
			this.listenTo(this.event, 'errorKeyAct', this.hideAll);
			this.listenTo(this.event, 'errorKey', this.notFoundError);
			this.listenTo(this.event, 'errorPass', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#pwResetActBodyMessageError").hide();
			this.$("#pwResetActBodyMessageNotFoundError").hide();
			this.$("#pwResetActBodyMessageKeyProcessing").hide();
			this.$("#pwResetActBodyMessagePasswordProcessing").hide();
			this.$("#pwResetActBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetActBodyMessageError").show();
		},
		
		notFoundError: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetActBodyMessageNotFoundError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetActBodyMessageSuccess").show();
		},
		
		keyProcessing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetActBodyMessageKeyProcessing").show();
		},
		
		passProcessing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetActBodyMessagePasswordProcessing").show();
		},
	});
	
	var PwActView = Backbone.View.extend({
		el: $("#pwResetActContent"),
		
		initialize: function(options) {
			this.pwKeyModel = options.pwKeyModel;
			this.pwResetModel = options.pwResetModel;
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			this.message = new PwActMessageView({el: this.$("#pwResetActBodyMessage"), event: this.event});
			this.content = new PwActContentView({
					el: this.$("#pwResetActBodyContent"), 
					event: this.event, 
					pwKeyModel: this.pwKeyModel, 
					pwResetModel: this.pwResetModel,
					submittedData: this.submittedData});
			this.footer = new PwActFooterView({el: this.$("#pwResetActFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingKeySuccess', this.keySuccess);
			this.listenTo(this.event, 'savingKeyError', this.keyError);
			this.listenTo(this.event, 'savingResetSuccess', this.resetSuccess);
			this.listenTo(this.event, 'savingResetError', this.resetError);
		},
		
		render: function () {
			this.event.trigger("default");
			return this;
		},
		
		keyError: function(model, error) {		
			if(this.submittedData.isSubmitted){
				//Key is either invalid or not found
				this.event.trigger("errorKey");
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		keySuccess: function (model) {
			this.submittedData.isSubmitted = false;
			this.event.trigger("success");
			
			if(model.isActivated()){
				//Key already activated
				this.event.trigger("errorKeyAct");
			} else {
				this.event.trigger("defaultPass");
			}
			
			
		},
		
		resetError: function(model, error) {		
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("errorPass");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("errorPass:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("errorPass");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		resetSuccess: function () {
			this.submittedData.isSubmitted = false;
			this.event.trigger("success");
		},
		
		processKey: function () {
			this.event.trigger("save");
		}
	});
	
	return PwActView;  
});